module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBoldItalic.e59d3264.ttf";